
<script setup>
import ResetPasswordForm from '@/components/ResetPasswordForm.vue'
</script>

<template>
  <div>
    <reset-password-form />
  </div>
</template>

